function unescapeHTML(str) {
  if (typeof str !== 'string') return str;

  const map = {
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&amp;': '&',
  };

  return str.replace(/&lt;|&gt;|&quot;|&#39;|&amp;/g, (m) => map[m]);
}

export default unescapeHTML;
